import React, { useState, useEffect } from 'react';
import { Controller } from 'react-hook-form';
import { Autocomplete } from '@mui/material';
import {
  TextField,
  CircularProgress,
  InputLabel,
  FormHelperText,
  InputAdornment,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import get from 'lodash/get';
import { useStyles } from './style';
import { getClientService } from './services/ClientIdComboServices';
import {Icons} from 'components';
const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(1),
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input': {
      padding: '1.5px 4px',
    },
    '& .MuiInputLabel-formControl': {
      top: '-7px',
      color: '#546e7a',
      fontSize: '12px',
    },
    '& .MuiInputAdornment-root': { color: '#546e7a' },
  },
}))(TextField);

const ClientIdCombo = ({
  methods,
  setValueIndex = false,
  name = 'scClientId',
  label = 'کلید های اتصال',
  required = false,
}) => {
  const { formState: { errors }, control, setValue } = methods;
  const classes = useStyles();

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    (async () => {
      try {
        setLoading(true);

        const result = await getClientService();

        setLoading(false);
        let data = result.result;
        data = data.clients;
        if (data) {
          let list = [];
          list = data.map((val) => ({
            name: val.name,
            client_id: val.client_id,
          }));
          setList(list);

          if (setValueIndex !== false) {
            setValue('scClientId', list[setValueIndex]);
          }
        }
      } catch (error) { }
      setLoading(false);
    })();

  }, []);

  const hasErrorFunc = (name) => {
    if (!required) {
      return false;
    }
    return get(errors, name, false);
  };

  const hasError = hasErrorFunc(name);

  return (
    <Controller
      name={name}
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          selectOnFocus
          onChange={(event, newValue) => {
            onChange(newValue);
          }}
          id="scClientId"
          isOptionEqualToValue={(option, value) => option.client_id === value.client_id}
          getOptionLabel={(option) => option.name}
          options={list}
          filterSelectedOptions
          loading={loading}
          value={value}
          renderInput={(params) => (
            <>
              <InputLabel shrink htmlFor={params?.name} className={classes.label}>
                {required && <span className={classes.asterisk}>* &nbsp;</span>}
                {label}
              </InputLabel>
              <BootstrapInput
                {...params}
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading && <CircularProgress color="inherit" size={20} />}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icons icon='Search' color="#546e7a" size="18" />
                    </InputAdornment>
                  ),
                }}
              />
              {hasError && (
                <FormHelperText id="my-helper-text" className={classes.asterisk}>
                  {errors?.[name]?.message}
                </FormHelperText>
              )}
            </>
          )}
        />
      )}
      control={control}
      rules={{
        required: 'فیلد کلید اتصال الزامی است.',
      }}
      defaultValue={null}
    />
  );
};

export default ClientIdCombo;
